__turbopack_context__.v({
  "btnContainer": "OffersModal-module__es-yza__btnContainer",
  "modal": "OffersModal-module__es-yza__modal",
  "modalContainer": "OffersModal-module__es-yza__modalContainer",
  "offersModalFadeIn": "OffersModal-module__es-yza__offersModalFadeIn",
  "root": "OffersModal-module__es-yza__root",
});
